module.exports = __webpack_public_path__ + "static/media/yhq-small.619227d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yhq-small.png
// module id = 586
// module chunks = 6